<p-dialog [(visible)]="changePassDialog" [style]="{width: '450px'}" header="Change Password" [modal]="true"
    [closable]="isDefaultPasswordChange" styleClass="p-fluid">

    <ng-template pTemplate="content">
        <form #changePasswordForm="ngForm"
            (ngSubmit)="confirmPassword == changePassword.password && changePasswordForm.form.valid && savePassword()">
            <div class="p-field">

                <label for="currentPassword">Current Password</label><span class="p-pl-1 p-error">*</span>
                <p-password id="currentPassword" name="currentPassword" required autofocus #currentPassword="ngModel"
                    [(ngModel)]="changePassword.currentPassword" [toggleMask]="true" [feedback]=false
                    [indicator]="false"></p-password>
                <small
                    *ngIf="(currentPassword.touched || currentPassword.dirty || changePasswordForm.submitted) && currentPassword.errors?.required"
                    class="p-error">Current Password is required.</small>
            </div>
            <div class="p-field">
                <label for="password"> New Password</label><span class="p-pl-1 p-error">*</span>
                <p-password id="pass" name="pass" required autofocus #pass="ngModel" [feedback]=false
                    [indicator]="false"
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*[0-9]).{8,30}$"
                    [(ngModel)]="changePassword.password" [toggleMask]="true"></p-password>
                <small *ngIf="(pass.touched || pass.dirty || changePasswordForm.submitted) &&  pass.errors?.required"
                    class="p-error">New Password is required.
                </small>
                <small
                    *ngIf="(pass.touched || pass.dirty || changePasswordForm.submitted) && !pass.errors?.required && pass.errors?.pattern"
                    class="p-error">Password must be 8-30 characters long, include uppercase, lowercase, and special characters, and must not contain numbers.
                </small>
            </div>
            <div class="p-field">
                <label for="confirmPassword">Confirm Password </label><span class="p-pl-1 p-error">*</span>
                <p-password id="confirmpass" name="confirmPass" required autofocus #confirmPass="ngModel"
                    [feedback]="false" [indicator]="false" [(ngModel)]="confirmPassword" [toggleMask]="true">
                </p-password>
                <small class="p-error"
                    *ngIf="(confirmPass.touched || confirmPass.dirty || changePasswordForm.submitted) &&  confirmPass.errors?.required">Confirm
                    Password is required.</small>
                <small class="p-error"
                    *ngIf="(confirmPass.touched || confirmPass.dirty || changePasswordForm.submitted) && !confirmPass.errors?.required && confirmPassword !== changePassword.password">
                    Confrim Password And Password Must be same
                </small>
            </div>
            <div class="p-grid">
                <div *ngIf="isDefaultPasswordChange == false" class="p-col-12">
                    <label class="p-error bold">Note: Please change your default login password.</label>
                </div>
                <div class="p-col-12">
                    <button pButton pRipple label="Save" icon="pi pi-check" [disabled]="!changePasswordForm.form.valid"
                        class="p-button-text parent-custom-button " type="submit"></button>
                    <button *ngIf="isDefaultPasswordChange" pButton pRipple label="Cancel" icon="pi pi-times"
                        class="p-button-text parent-custom-button  p-button-danger" type="button"
                        (click)="hideDialog()"></button>
                </div>
            </div>
        </form>
    </ng-template>
</p-dialog>